import axios from "axios";
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Context
import { SearchProvider } from "./context/SearchContext";
import OrderTracking from "./pages/OrderTracking.jsx";

// Layout
import Header from "./Component/Header.jsx";
import Footer from "./Component/Footer.jsx";
import ScrollToTop from "./Component/ScrollToTop.jsx";
import ResetPassword from "./pages/ResetPassword";
import ProtectedRoute from "./Component/ProtectedRoute.jsx";

// Pages
import Home from "./pages/Home.jsx";
import AboutUs from "./pages/About/AboutUs.jsx";
import Blog from "./pages/About/Blog.jsx";
import BlogCategory from "./pages/About/BlogCategory.jsx";
import Contact from "./pages/About/Contact.jsx";
import ProductDetail from "./pages/ProductDetail.jsx";

import InvoicePage from "./pages/Shop/InvoicePage.jsx";
import DeleteAccount from "./pages/DeleteAccount";

import Shop from "./pages/Shop/Shop.jsx";
import ShopGridCol3 from "./pages/Shop/ShopGridCol3.jsx";
import PaymentStatus from "./pages/Shop/PaymentStatus.jsx";
import ShopCart from "./pages/Shop/ShopCart.jsx";
import ShopWishList from "./pages/Shop/ShopWishList.jsx";

import Payment from "./pages/Shop/Payment.jsx";
import PaymentSuccess from "./pages/Shop/PaymentSuccess.jsx";

import ShopCheckOut from "./pages/Shop/ShopCheckOut.jsx";
import OrderConfirmation from "./pages/Shop/OrderConfirmation.jsx";
import RetryPayment from "./pages/Shop/RetryPayment.jsx";

/* 🔥 NEW ADDRESS MANAGER IMPORT */
import AddressManager from "./pages/Shop/AddressManager.jsx";

// Store
import StoreList from "./pages/store/StoreList.jsx";
import SingleShop from "./pages/store/SingleShop.jsx";

// Account
import Profile from "./pages/Accounts/Profile.jsx";
import MyAccountOrder from "./pages/Accounts/MyAccountOrder.jsx";
import MyAccountSetting from "./pages/Accounts/MyAcconutSetting.jsx";
import MyAccountNotification from "./pages/Accounts/MyAcconutNotification.jsx";
import MyAccountPaymentMethod from "./pages/Accounts/MyAcconutPaymentMethod.jsx";
import MyAccountAddress from "./pages/Accounts/MyAccountAddress.jsx";
import MyAccountForgetPassword from "./pages/Accounts/MyAccountForgetPassword.jsx";
import MyAccountSignIn from "./pages/Accounts/MyAccountSignIn.jsx";
import MyAccountSignUp from "./pages/Accounts/MyAccountSignUp.jsx";

// Policies
import ReturnReplacementPolicy from "./pages/ReturnReplacementPolicy.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import TermsOfService from "./pages/TermsOfService.jsx";
import RefundPolicy from "./pages/RefundPolicy.jsx";
import ShippingPolicy from "./pages/ShippingPolicy.jsx";
import FAQ from "./pages/Faq.jsx";

// Other
import NotFound from "./pages/NotFound.jsx";

const App = () => {

useEffect(() => {
axios
.get("https://api.freshcart4u.com")
.then(() => console.log("🚀 Backend API Running..."))
.catch(() => {});
}, []);

return (
<SearchProvider>

<ScrollToTop />  
  <Header />  

  <Routes>  

    {/* ================= HOME ================= */}  
     

<Route path="/" element={<Home />} />   

    {/* ================= SHOP ================= */}  
    <Route path="/Shop" element={<Shop />} />  
    <Route path="/ShopCart" element={<ShopCart />} />  
    <Route path="/ShopWishList" element={<ShopWishList />} />  
    <Route path="/ShopGridCol3" element={<ShopGridCol3 />} />  
    <Route path="/product/:id" element={<ProductDetail />} />  

    {/* ================= INVOICE ================= */}  
    <Route  
      path="/invoicePage"  
      element={  
        <ProtectedRoute>  
          <InvoicePage />  
        </ProtectedRoute>  
      }  
    />  

    {/* ================= CHECKOUT ================= */}  
    <Route  
      path="/checkout"  
      element={  
        <ProtectedRoute>  
          <ShopCheckOut />  
        </ProtectedRoute>  
      }  
    />  

    {/* 🔥 NEW ADDRESS MANAGER ROUTE */}  
    <Route  
      path="/address-manager"  
      element={  
        <ProtectedRoute>  
          <AddressManager />  
        </ProtectedRoute>  
      }  
    />  

    {/* ================= PAYMENT ================= */}  
    <Route  
      path="/payment"  
      element={  
        <ProtectedRoute>  
          <Payment />  
        </ProtectedRoute>  
      }  
    />  

    <Route path="/payment-success" element={<PaymentSuccess />} />  

    <Route  
      path="/payment-status/:orderId"  
      element={  
        <ProtectedRoute>  
          <PaymentStatus />  
        </ProtectedRoute>  
      }  
    />  

    <Route  
      path="/retry-payment/:orderId"  
      element={  
        <ProtectedRoute>  
          <RetryPayment />  
        </ProtectedRoute>  
      }  
    />  

    {/* ================= ORDER ================= */}  
    <Route  
      path="/order-confirmation/:orderId"  
      element={  
        <ProtectedRoute>  
          <OrderConfirmation />  
        </ProtectedRoute>  
      }  
    />  

    <Route  
      path="/order-tracking/:orderId"  
      element={  
        <ProtectedRoute>  
          <OrderTracking />  
        </ProtectedRoute>  
      }  
    />  

    {/* ================= RESET / DELETE ================= */}  
    <Route path="/reset-password/:token" element={<ResetPassword />} />  
    <Route path="/delete-account" element={<DeleteAccount />} />  

    {/* ================= STORE ================= */}  
    <Route path="/StoreList" element={<StoreList />} />  
    <Route path="/SingleShop" element={<SingleShop />} />  

    {/* ================= ACCOUNT ================= */}  
    <Route path="/MyAccountSignIn" element={<MyAccountSignIn />} />  
    <Route path="/MyAccountSignUp" element={<MyAccountSignUp />} />  
    <Route path="/profile" element={<Profile />} />  
    <Route path="/MyAccountSetting" element={<MyAccountSetting />} />  
    <Route path="/MyAccountAddress" element={<MyAccountAddress />} />  
    <Route path="/MyAccountForgetPassword" element={<MyAccountForgetPassword />} />  
    <Route path="/MyAccountNotification" element={<MyAccountNotification />} />  
    <Route path="/MyAccountPaymentMethod" element={<MyAccountPaymentMethod />} />  

    <Route  
      path="/my-orders"  
      element={  
        <ProtectedRoute>  
          <MyAccountOrder />  
        </ProtectedRoute>  
      }  
    />  

    {/* ================= POLICIES ================= */}  
    <Route path="/return-replacement-policy" element={<ReturnReplacementPolicy />} />  
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />  
    <Route path="/terms-of-service" element={<TermsOfService />} />  
    <Route path="/refund-policy" element={<RefundPolicy />} />  
    <Route path="/shipping-policy" element={<ShippingPolicy />} />  
    <Route path="/faq" element={<FAQ />} />  

    {/* ================= ABOUT ================= */}  
    <Route path="/Blog" element={<Blog />} />  
    <Route path="/BlogCategory" element={<BlogCategory />} />  
    <Route path="/Contact" element={<Contact />} />  
    <Route path="/AboutUs" element={<AboutUs />} />  

    {/* ================= 404 ================= */}  
    <Route path="*" element={<NotFound />} />  

  </Routes>  

  <Footer />  

</SearchProvider>

);
};

export default App; 